import { useEffect } from 'react';

import Layout from './../layoutComponents/layout';

import InitPageHelper from '../helpers/PageInitHelper';

import generalData from '../../generalData';

export default function App(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  InitPageHelper.PageInitHelper(props.pageData);
  return (
    <Layout>
      <section className="container max-w-6xl mx-auto px-2 lg:px-16 text-gray-800">
        <h1 className="text-3xl font-bold text-center my-16 text-center text-primary-800">
          Política de Privacidad y Protección de Datos
        </h1>
        <p className="text-center">
          En GrIS (Grupo de Ingeniería de Software), estamos comprometidos con
          la protección de la privacidad y seguridad de los datos personales de
          nuestros usuarios, colaboradores y socios. Este documento describe
          cómo recogemos, utilizamos y protegemos la información que nos
          proporcionas a través de nuestro sitio web y otros canales digitales.
        </p>

        <div className="bg-primary-50 rounded-xl p-2 lg:p-8 mt-16 shadow-sm flex flex-col gap-16">
          <div className="flex flex-col gap-4">
            <h2 className="text-xl font-semibold">
              1. Recopilación de Información
            </h2>
            <p>
              GrIS puede recopilar los siguientes tipos de datos personales a
              través de sus formularios de contacto, inscripción o participación
              en eventos:
            </p>
            <ul className="list-disc ml-5">
              <li>Nombre y apellidos</li>
              <li>Correo electrónico</li>
              <li>Número de teléfono</li>
              <li>Información académica o profesional</li>
            </ul>
            <p>
              La recopilación de estos datos se realiza con el único fin de
              brindarte un mejor servicio y facilitar el contacto y las
              actividades relacionadas con nuestros proyectos y eventos.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <h2 className="text-xl font-semibold">2. Uso de la Información</h2>
            <p>Los datos personales proporcionados serán utilizados para:</p>
            <ul className="list-disc ml-5">
              <li>
                Mantenerte informado sobre nuestros proyectos, actividades,
                eventos y noticias relevantes para el campo de la ingeniería de
                software.
              </li>
              <li>Responder a consultas o solicitudes de información.</li>
              <li>
                Facilitar la participación en eventos organizados por GrIS.
              </li>
              <li>
                Cumplir con las obligaciones legales o regulatorias que
                correspondan.
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            {' '}
            <h2 className="text-xl font-semibold">
              3. Protección de la Información
            </h2>
            <p>
              Implementamos medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales frente al acceso no
              autorizado, alteración, divulgación o destrucción. Solo el
              personal autorizado de GrIS tendrá acceso a tus datos, y lo hará
              exclusivamente para los fines indicados en esta política.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <h2 className="text-xl font-semibold">
              4. Compartición de la Información
            </h2>
            <p>
              GrIS no compartirá, venderá ni alquilará tus datos personales a
              terceros, salvo en los siguientes casos:
            </p>
            <ul className="list-disc ml-5">
              <li>Cuando sea requerido por la ley.</li>
              <li>
                Cuando sea necesario para proteger los derechos, la propiedad o
                la seguridad de GrIS o de otros.
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <h2 className="text-xl font-semibold">5. Tus Derechos</h2>
            <p>
              De acuerdo con la normativa vigente en materia de protección de
              datos, tienes derecho a:
            </p>
            <ul className="list-disc ml-5">
              <li>Acceder, corregir o actualizar tus datos personales.</li>
              <li>
                Solicitar la eliminación de tus datos de nuestros registros.
              </li>
              <li>
                Limitar o rechazar el procesamiento de tus datos personales en
                determinadas circunstancias.
              </li>
            </ul>
            <p>
              Si deseas ejercer cualquiera de estos derechos, puedes ponerte en
              contacto con nosotros a través del correo electrónico{' '}
              {generalData.contact.email}.
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <h2 className="text-xl font-semibold">
              6. Cambios en la Política de Privacidad
            </h2>
            <p>
              GrIS se reserva el derecho de actualizar o modificar esta política
              de privacidad en cualquier momento. Te notificaremos cualquier
              cambio importante mediante un aviso en nuestro sitio web o por
              correo electrónico.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <h2 className="text-xl font-semibold">7. Contacto</h2>
            <p>
              Si tienes alguna duda o inquietud sobre nuestra política de
              privacidad o el tratamiento de tus datos personales, no dudes en
              contactarnos a través de {generalData.contact.email}.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
